export default __webpack_public_path__ + "static/media/content-trends.414c98d1.svg";